// extracted by mini-css-extract-plugin
export default {"button":"MkNy2DAsQgi5z9Fj_A8x","profileInitials":"gJIxf0UBhV0dIz3Eve_e"};